import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Collapse,
  Row,
  Button,
} from "reactstrap";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// Componentes
import SectionComponent from "../Apps/Personalization/SectionComponent";
import LoadingSkelentonTable from "../../components/loadingSkeletonTable";
import ModalNewStatusRsvp from "./ModalNewStatusRsvp";
import ModalEditStatusRsvp from "./ModalEditStatusRsvp";
import Pagination from "../../components/Paginationv3";
import ActionButtonRounded from "../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../components/Buttons/DeleteButton";
import IconButton from "../../components/Buttons/IconButton";
// service
import {
  getStatusRsvp,
  editStatusRsvp,
} from "../../utils/services/statusRsvp";

function StatusRsvp(props) {
  // Contrato ativo — vem do Redux e é usado como filtro do backend
  // (GET /status-rsvp/contract/:contractId).
  const contractId = props.state.global_user_data.data.theme[0]?.id;

  // State de layout
  const [isCollapse, setIsCollapse] = useState(false);

  // State de modais
  const [modalNew, setModalNew] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);

  // State de alertas
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertConfirmDelete, setAlertConfirmDelete] = useState(false);
  const [alertConfirmReactivate, setAlertConfirmReactivate] = useState(false);

  // State de loading
  const [isLoading, setIsLoading] = useState(false);

  // State de dados / paginação
  const [statusList, setStatusList] = useState([]);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [search, setSearch] = useState("");
  const [enabled, setEnabled] = useState(true);

  // State de linha selecionada para editar/excluir/reativar
  const [editOne, setEditOne] = useState(null);
  const [deleteOne, setDeleteOne] = useState(null);
  const [reactivateOne, setReactivateOne] = useState(null);

  // Alterna o `enabled` do registro (soft delete / reativação)
  async function toggleEnabled(nextEnabled, item) {
    const res = await editStatusRsvp({
      id: item.id,
      data: { enabled: nextEnabled },
    });
    if (res && res.status >= 200 && res.status < 300) {
      getListStatusRsvp();
      setAlertSuccess(true);
      setAlertConfirmDelete(false);
      setAlertConfirmReactivate(false);
    }
  }

  // Busca a listagem paginada com filtros de search e enabled
  async function getListStatusRsvp() {
    if (!contractId) return;
    setIsLoading(true);
    const res = await getStatusRsvp({
      contractId,
      offset: currentIndex,
      limit: itemsPerPage,
      search,
      enabled,
    });
    setIsLoading(false);
    if (res && Array.isArray(res.data)) {
      setStatusList(res.data);
      setCountData(res.total || 0);
    }
  }

  useEffect(() => {
    getListStatusRsvp();
  }, [search, currentIndex, itemsPerPage, enabled, contractId]);

  return (
    <>
      {modalNew && (
        <ModalNewStatusRsvp
          isOpen={modalNew}
          toggle={() => setModalNew(!modalNew)}
          getListStatusRsvp={getListStatusRsvp}
          contractId={contractId}
        />
      )}

      {modalEdit && (
        <ModalEditStatusRsvp
          isOpen={modalEdit}
          toggle={() => setModalEdit(!modalEdit)}
          editOneStatusRsvp={editOne}
          getListStatusRsvp={getListStatusRsvp}
        />
      )}

      {alertConfirmDelete && (
        <SweetAlert
          title={`Deseja deletar ${deleteOne.description}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => toggleEnabled(false, deleteOne)}
          onCancel={() => setAlertConfirmDelete(false)}
        />
      )}

      {alertConfirmReactivate && (
        <SweetAlert
          title={`Deseja reativar ${reactivateOne.description}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => toggleEnabled(true, reactivateOne)}
          onCancel={() => setAlertConfirmReactivate(false)}
        />
      )}

      {alertSuccess && (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => setAlertSuccess(false)}
        >
          Operação realizada com sucesso
        </SweetAlert>
      )}

      <Helmet>
        <title>Status RSVP | Inteegra Plus</title>
      </Helmet>

      <Card>
        <CardBody>
          <CardTitle>Status RSVP</CardTitle>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsCollapse}
                isOpen={isCollapse}
              />
              <Collapse isOpen={isCollapse}>
                <Row className="mobile-btns-top">
                  <div onClick={() => setEnabled(!enabled)}>
                    {!enabled ? "Filtrar: Ativos" : "Filtrar: Inativos"}
                  </div>
                </Row>
                <ActionButtonRounded
                  title="Adicionar Status RSVP"
                  onClick={() => setModalNew(true)}
                  type="mobile"
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              <Button
                color="secondary"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => setEnabled(!enabled)}
              >
                {!enabled ? "Filtrar: Ativos" : "Filtrar: Inativos"}
              </Button>

              <ActionButtonRounded
                title="Adicionar Status RSVP"
                onClick={() => setModalNew(true)}
                margin="0 0 0 5px"
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={3} />
                ) : (
                  statusList.length > 0 &&
                  statusList.map((e, i) => (
                    <tr key={i}>
                      <td>{e.id}</td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 12px",
                            borderRadius: 6,
                            fontSize: 13,
                            fontWeight: 500,
                            backgroundColor: e.backgroundColor || "#e9ecef",
                            color: e.textColor || "#212529",
                          }}
                        >
                          {e.description}
                        </span>
                      </td>
                      <td>
                        {enabled ? (
                          <>
                            <i
                              className="mdi mdi-pencil"
                              style={{
                                color: "green",
                                fontSize: 17,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setEditOne(e);
                                setModalEdit(true);
                              }}
                            />{" "}
                            <DeleteButton
                              onClick={() => {
                                setDeleteOne(e);
                                setAlertConfirmDelete(true);
                              }}
                            />
                          </>
                        ) : (
                          <IconButton
                            className="mdi mdi-account-reactivate"
                            action="U"
                            color="green"
                            onClick={() => {
                              setReactivateOne(e);
                              setAlertConfirmReactivate(true);
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        <Pagination
          data={statusList}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state };
};

export default connect(mapStateToProps)(StatusRsvp);
